import { Logger } from '@utils/logger/logger';
import WeddingApi from '../../../lib/rfq/api/weddings';

const FETCH_BOOKINGS = 'FETCH_BOOKINGS';
export const FETCH_BOOKINGS_SUCCESS = 'FETCH_BOOKINGS_SUCCESS';
const FETCH_BOOKINGS_FAILURE = 'FETCH_BOOKINGS_FAILURE';

export function createClient(category, member) {
	return new WeddingApi({
		category,
		member,
		formData: {},
	});
}

/** @internal */
export const initialState = {
	isFetching: false,
	bookings: [],
	error: null,
};

// biome-ignore lint/style/useDefaultParameterLast: is needed for redux
export default function reducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_BOOKINGS:
			return {
				...state,
				isFetching: true,
			};
		case FETCH_BOOKINGS_SUCCESS:
			return {
				...state,
				isFetching: false,
				bookings: action.bookings,
			};
		case FETCH_BOOKINGS_FAILURE:
			return {
				...state,
				isFetching: false,
				error: action.error,
			};
		default:
			return state;
	}
}

export function fetchBookings(category, member) {
	const weddingClient = createClient(category, member);
	return (dispatch) => {
		dispatch({ type: FETCH_BOOKINGS });
		return weddingClient.getAllBookings().then(
			(result) => {
				const bookingsVendors = (result ?? []).map((booking) => {
					return {
						bookingId: booking.id,
						vendorId: booking.vendor_profile_id,
					};
				});
				dispatch({ type: FETCH_BOOKINGS_SUCCESS, bookings: bookingsVendors });
				return bookingsVendors;
			},
			(error) => {
				dispatch({ type: FETCH_BOOKINGS_FAILURE, error });
				Logger.error({
					log_message: 'Error fetching bookings',
					errorToLog: error,
					newRelic: true,
				});
			},
		);
	};
}
